import React, { useState, useEffect } from 'react';
import { useAuth } from '../AuthContext/AuthContext';
import { useLocation } from 'react-router-dom';
import Navbar from '../Navbar/Navbar';
import { useCart } from '../CartContext/CartContext';

interface Product {
  name: string;
  quantity: number;
}

interface TransactionData {
  name: string;
  email: string;
  products: Product[];
  address: string;
  totalAmount: string;
}

const Purchase: React.FC = () => {
  const location = useLocation();
  const [transactionData, setTransactionData] = useState<TransactionData | null>(null);
  const { clearCart } = useCart();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const name = searchParams.get('name');
    const email = searchParams.get('email');
    const products = searchParams.get('products') ? JSON.parse(searchParams.get('products') as string) : [];
    const address = searchParams.get('address');
    const totalAmount = searchParams.get('totalAmount');

    if (name && email && products && address && totalAmount) {
      setTransactionData({
        name,
        email,
        products,
        address,
        totalAmount
      });

      clearCart();
    }
  }, [location.search, clearCart]);

  const {  logout } = useAuth();

  return (
    <>
      <div className='bg-white'>
        <Navbar /> 
        TRACK ORDER DASHBOARD IN PROGRESS
        <button onClick={logout} className="text-white bg-[#5d5d5e]">
          Logout
        </button>
        <div>
          <h1>Home</h1>
          {transactionData ? (
            <div>
              <h2>Transaction Details</h2>
              <p>Name: {transactionData?.name}</p>
              <p>Email: {transactionData?.email}</p>
              <p>Address: {transactionData?.address}</p>
              <p>Total Amount: {transactionData?.totalAmount}</p>
              <h3>Products</h3>
              <ul>
                {transactionData.products.map((product, index) => (
                  <li key={index}>{product.name} - Quantity: {product.quantity}</li>
                ))}
              </ul>
            </div>
          ) : (
            <p>No transaction data available</p>
          )}
        </div>
      </div>
    </>
  );
};

export default Purchase;
